import { render, staticRenderFns } from "./SideMenuTeacher.vue?vue&type=template&id=6a10d9cd&scoped=true"
import script from "./SideMenuTeacher.vue?vue&type=script&lang=js"
export * from "./SideMenuTeacher.vue?vue&type=script&lang=js"
import style0 from "./SideMenuTeacher.vue?vue&type=style&index=0&id=6a10d9cd&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a10d9cd",
  null
  
)

export default component.exports